export const MERGE_OPTION_IDS = ['64be14c7dd4a6cbf7c8159b9','64ca1907e47e2a8f401caa19']
export const SWITCH_AD_PARTNER_DELAY = 32000
